import { capitalize } from 'lodash';

import {
    ALL_COUNTRIES,
    CONSENT_TITLE,
    GOVT_ID_COPY,
    PASSPORT_DOC_TYPE,
    US_COUNTRY_CODE,
} from './constants';

export const getReturnLabel = (companyName) => `Return To ${companyName}`;

export const getConsentTitle = (eepCount) => {
    if (eepCount > 1) {
        return `${CONSENT_TITLE} & Background Checks`;
    }

    return eepCount === 1 ? `${CONSENT_TITLE} & Background Check` : CONSENT_TITLE;
};

export const getConsentVerifiedLine = (eepLabels) => {
    if (eepLabels.length > 1) {
        const last = eepLabels[eepLabels.length - 1];
        return `Your Identity, ${eepLabels.slice(0, -1).join(', ')} and ${last} will be verified.`;
    }

    return eepLabels.length === 1
        ? `Your Identity and ${eepLabels[0]} will be verified.`
        : 'Your identity will be verified.';
};

export const getAttemptText = (attempts) => {
    const max = Number(attempts) || 1;
    return `${max}/${max} ${max > 1 ? 'attempts' : 'attempt'} left`;
};

export const getVerificationStepLabel = (current, total) => `Verification ${current} of ${total}`;

export const getGovtIdTitle = (docTypes) =>
    docTypes.length > 0 && !docTypes.includes(PASSPORT_DOC_TYPE)
        ? GOVT_ID_COPY.TITLE_ID_ONLY
        : GOVT_ID_COPY.TITLE_WITH_PASSPORT;

// Outside the US every government ID is accepted, so the restriction only shows for US flows.
export const getAcceptedDocuments = (docTypes, countries) => {
    const isAllCountries = countries === ALL_COUNTRIES;

    if (!docTypes.length || (!isAllCountries && !countries.includes(US_COUNTRY_CODE))) {
        return null;
    }

    const isOnlyUs = !isAllCountries && countries.length === 1;

    return {
        inline: isOnlyUs && docTypes.length <= 3,
        labels: docTypes.map(capitalize),
    };
};
